module.exports = __webpack_public_path__ + "img/62e59aa1f8db813a8f4b526ebc645f75.png";